/**
 * Beessential performance helper (round 6)
 * - Delay TargetBay / AdRoll until idle / interaction
 * BayEngage email popup is left to the app (delay/exit-intent in BayEngage admin).
 * We no longer rewrite content_for_header (that regressed mobile lab scores).
 */
(function () {
  function runScript(oldScript) {
    var script = document.createElement('script');
    Array.prototype.forEach.call(oldScript.attributes || [], function (attr) {
      script.setAttribute(attr.name, attr.value);
    });
    if (oldScript.src) {
      script.async = true;
    } else {
      script.appendChild(
        document.createTextNode(oldScript.textContent || oldScript.innerHTML || '')
      );
    }
    document.body.appendChild(script);
  }

  function injectTbShopify() {
    var tpl = document.getElementById('be-tb-shopify-template');
    if (!tpl || tpl.getAttribute('data-injected') === '1') return;
    tpl.setAttribute('data-injected', '1');

    var scripts = [];
    if (tpl.content && tpl.content.querySelectorAll) {
      scripts = Array.prototype.slice.call(tpl.content.querySelectorAll('script'));
    }
    if (!scripts.length) {
      var holder = document.createElement('div');
      holder.innerHTML = tpl.innerHTML;
      scripts = Array.prototype.slice.call(holder.querySelectorAll('script'));
    }
    scripts.forEach(runScript);
  }

  function schedule(fn, timeout) {
    var ran = false;
    function once() {
      if (ran) return;
      ran = true;
      try {
        fn();
      } catch (e) {
        /* non-fatal */
      }
    }

    ['pointerdown', 'keydown', 'scroll', 'touchstart'].forEach(function (evt) {
      window.addEventListener(evt, once, { once: true, passive: true });
    });

    if ('requestIdleCallback' in window) {
      requestIdleCallback(once, { timeout: timeout || 4000 });
    } else {
      window.addEventListener('load', function () {
        setTimeout(once, 1);
      });
    }
  }

  schedule(injectTbShopify, 4000);
})();
